(function () {
  'use strict';

  var _observer = null;
  var _sentinel = null;

  function cleanup() {
    if (_observer) { _observer.disconnect(); _observer = null; }
    if (_sentinel && _sentinel.parentNode) { _sentinel.remove(); _sentinel = null; }
  }

  function getSectionId() {
    var el = document.querySelector('[data-hdt-init]');
    return el ? el.dataset.hdtInit : null;
  }

  function showLoader(container) {
    var existing = container.querySelector('.hdt-search-sort-loader');
    if (existing) return existing;
    var loader = document.createElement('div');
    loader.className = 'hdt-search-sort-loader';
    loader.setAttribute('aria-label', 'Loading all results');
    loader.innerHTML =
      '<div class="hdt-search-sort-loader__spinner">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 66" aria-hidden="true">' +
          '<circle fill="none" stroke="currentColor" stroke-width="6" cx="33" cy="33" r="30"' +
            ' stroke-dasharray="150 50" stroke-linecap="round">' +
            '<animateTransform attributeName="transform" type="rotate"' +
              ' from="0 33 33" to="360 33 33" dur="0.9s" repeatCount="indefinite"/>' +
          '</circle>' +
        '</svg>' +
      '</div>';
    container.insertBefore(loader, container.firstChild);
    return loader;
  }

  function hideLoader(loader) {
    if (loader && loader.parentNode) loader.remove();
  }

  async function fetchPageProducts(pageUrl, sectionId) {
    var url = new URL(pageUrl);
    url.searchParams.set('section_id', sectionId);
    var res = await fetch(url.toString());
    if (!res.ok) return [];
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = doc.getElementById('products-' + sectionId);
    if (!grid) return [];
    return Array.from(grid.querySelectorAll(':scope > .hdt-main-search__result-item')).map(function (el) {
      return document.importNode(el, true);
    });
  }

  function setupVirtualScroll(grid, container, remaining, perPage) {
    if (remaining.length === 0) return;

    var products = remaining;

    var sentinel = document.createElement('div');
    sentinel.className = 'hdt-search-virtual-sentinel hdt-pagination-wrapper';
    sentinel.setAttribute('loading', '');
    sentinel.innerHTML =
      '<div class="hdt-pagination__infinite-loader" aria-hidden="true">' +
        '<svg width="24" height="24" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
          '<circle fill="none" stroke="currentColor" stroke-width="6" cx="33" cy="33" r="30"' +
            ' stroke-dasharray="150 50" stroke-linecap="round">' +
            '<animateTransform attributeName="transform" type="rotate"' +
              ' from="0 33 33" to="360 33 33" dur="0.9s" repeatCount="indefinite"/>' +
          '</circle>' +
        '</svg>' +
      '</div>';

    container.insertBefore(sentinel, grid.nextSibling);
    _sentinel = sentinel;

    var loading = false;
    _observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || loading || products.length === 0) return;
      loading = true;
      requestAnimationFrame(function () {
        var batch = products.splice(0, perPage);
        batch.forEach(function (el) { grid.appendChild(el); });
        if (products.length === 0) {
          sentinel.remove();
          _sentinel = null;
          _observer.disconnect();
          _observer = null;
        }
        loading = false;
        if (typeof grid.reveal === 'function') grid.reveal();
      });
    }, { rootMargin: '400px' });

    _observer.observe(sentinel);
  }

  async function initSortedSearch() {
    cleanup();

    var sectionId = getSectionId();
    if (!sectionId) return;

    var grid = document.getElementById('products-' + sectionId);
    if (!grid) return;

    var totalPages = parseInt(grid.dataset.totalPages || '1', 10);
    var perPage = parseInt(grid.dataset.perPage || '12', 10);

    // Remove Shopify's pagination immediately to prevent its infinite-scroll from racing
    var existingPagination = document.querySelector('[loadmore-btn-wrapp]');
    if (existingPagination) existingPagination.remove();

    if (totalPages <= 1) return;

    var container = grid.closest('.hdt-product-grid-container');
    if (!container) return;

    var loader = showLoader(container);

    // Hide grid while sorting
    grid.style.visibility = 'hidden';

    try {
      // Collect products from the initial (first) page
      var allProducts = Array.from(grid.querySelectorAll(':scope > .hdt-main-search__result-item'));

      // Fetch all remaining pages in parallel
      var baseUrl = new URL(window.location.href);
      baseUrl.searchParams.delete('page');
      baseUrl.searchParams.delete('section_id');

      var promises = [];
      for (var p = 2; p <= totalPages; p++) {
        var u = new URL(baseUrl.toString());
        u.searchParams.set('page', p);
        promises.push(fetchPageProducts(u.toString(), sectionId));
      }

      var pageResults = await Promise.all(promises);
      pageResults.forEach(function (items) {
        Array.prototype.push.apply(allProducts, items);
      });

      // Sort by created_at descending — newest first
      allProducts.sort(function (a, b) {
        return parseInt(b.dataset.createdAt || '0', 10) - parseInt(a.dataset.createdAt || '0', 10);
      });

      // Replace grid contents with the first batch
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      var firstBatch = allProducts.splice(0, perPage);
      firstBatch.forEach(function (el) { grid.appendChild(el); });

      grid.style.visibility = '';
      hideLoader(loader);

      // Set up virtual scroll for the remaining sorted products
      setupVirtualScroll(grid, container, allProducts, perPage);

      if (typeof grid.reveal === 'function') grid.reveal();

    } catch (err) {
      grid.style.visibility = '';
      hideLoader(loader);
      console.error('[CPW Search Sort]', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortedSearch);
  } else {
    initSortedSearch();
  }

  // Re-run whenever facets.js re-renders the search section (filter/sort change)
  document.addEventListener('products:update', function () {
    requestAnimationFrame(initSortedSearch);
  });

})();
